import React from "react";
import ReactDOM from "react-dom/client";
import 'animate.css';
import "./theme.less";
import "./index.less";
import reportWebVitals from "./reportWebVitals";
import Routes from "@/configs/routes";
import "@/locales/i18n";
import VConsole from "vconsole";
import { UserInfoProvider } from "@/components/business/user-info-provider";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { getCookieValue, getUrlParamValue } from "./utils";
import { GLOBAL_KEYS, IS_DEV, IS_TEST } from "./configs";

dayjs.extend(utc);

/** 默认：1浅色 (0 暗色, 1 浅色) */
const theme = getUrlParamValue(location.href, "theme");
if (theme == "0") {
  document.body.classList.add("dark");
}

const lang = getUrlParamValue(location.href, "lang") || navigator.language;
if (lang) {
  localStorage.setItem("lang", lang);
}

/** 默认公制 (0 公制, 1 英制) */
const unit = getUrlParamValue(location.href, "unit") || navigator.language;
if (unit) {
  localStorage.setItem("unit", unit);
}

const cookie = getCookieValue(GLOBAL_KEYS.USER_TOKEN);
if (cookie) {
  localStorage.setItem(GLOBAL_KEYS.USER_TOKEN, cookie);
}

if (IS_DEV || IS_TEST) {
  new VConsole();
}

const root = ReactDOM.createRoot(document.getElementById("root") as ReactDOM.Container);
root.render(
  <UserInfoProvider>
    <Routes />
  </UserInfoProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
